import classNames from 'classnames';
import React from 'react';
import styles from './ButtonAsLink.module.css';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
};

const ButtonAsLink = ({ children, onClick, className }: Props) => {
  return (
    <button onClick={onClick} className={classNames(styles.button, className)}>
      {children}
    </button>
  );
};

export default ButtonAsLink;
